module.exports = __webpack_public_path__ + "media/images/payments/ogone-b48ea3f80cebc0d390690270e2dddf23.svg";